import * as Types from '../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type DeleteBlobMutationVariables = {
  uri: Types.Scalars['ID']
};


export type DeleteBlobMutation = (
  { __typename?: 'Mutation' }
  & Pick<Types.Mutation, 'deleteBlob'>
);

export const DeleteBlobDocument = gql`
    mutation DeleteBlob($uri: ID!) {
  deleteBlob(uri: $uri)
}
    `;
export type DeleteBlobMutationFn = ApolloReactCommon.MutationFunction<DeleteBlobMutation, DeleteBlobMutationVariables>;

    export function useDeleteBlobMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteBlobMutation, DeleteBlobMutationVariables>) {
      return ApolloReactHooks.useMutation<DeleteBlobMutation, DeleteBlobMutationVariables>(DeleteBlobDocument, baseOptions);
    };
export type DeleteBlobMutationHookResult = ReturnType<typeof useDeleteBlobMutation>;
export type DeleteBlobMutationResult = ApolloReactCommon.MutationResult<DeleteBlobMutation>;
export type DeleteBlobMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteBlobMutation, DeleteBlobMutationVariables>;